import script from "./EventItems.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItems.vue?vue&type=script&setup=true&lang=js"

import "./EventItems.vue?vue&type=style&index=0&id=6993fd6c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6993fd6c"]])

export default __exports__